var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fs-3" },
    [
      _c("preloader", {
        staticClass: "preloader prelative",
        attrs: { display: _vm.loading }
      }),
      _vm._v(" "),
      _c("header", { staticClass: "mb-5 billing-header mt--5 pt-0" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
          _c(
            "ul",
            { staticClass: "list-inline" },
            _vm._l(_vm.tabs, function(tab, tabIndex) {
              return _c(
                "li",
                {
                  key: tabIndex,
                  staticClass: "mr-5",
                  class: tab.active ? "active" : ""
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "pointer",
                      class: tab.permission == false ? "link-disabled" : "",
                      on: {
                        click: function($event) {
                          tab.permission ? _vm.handleTab(tab) : null
                        }
                      }
                    },
                    [_vm._v(_vm._s(tab.label))]
                  )
                ]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container-small m-auto" },
        [
          _c(
            "keep-alive",
            [
              !_vm.loading
                ? _c(_vm.currentTab.component, {
                    tag: "component",
                    attrs: { corporation: _vm.corporation },
                    on: { load: _vm.load }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "round-64 relative dinlineb valign-middle primary-50-bkg"
      },
      [
        _c("i", {
          staticClass: "fab fa-sellsy absolute-center white",
          staticStyle: { "font-size": "26px" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }